import {settle} from './settle.js';

/**
 * Roll to the digit in the element, then restore its plain text (#32160, #32163).
 * @param {HTMLElement} element A clipped, one-em-high digit with data-turns.
 * @param {{delay: number, duration: number, easing: string}} timing
 * @returns {Animation}
 */
export function rollDigit(element, timing) {
    const digit = element.textContent.trim();
    const steps = Number(element.dataset.turns) * 10 + Number(digit);
    const strip = document.createElement('span');
    strip.className = 'relative block h-full';
    strip.textContent = digit;

    // WebKit rounds line boxes. Position each row against one cell to prevent cumulative drift.
    for (let index = 0; index < steps; index++) {
        const row = document.createElement('span');
        row.className = 'absolute inset-x-0 h-full';
        row.style.top = `${(index - steps) * 100}%`;
        row.textContent = String(index % 10);
        strip.append(row);
    }
    element.replaceChildren(strip);
    const animation = strip.animate([{translate: `0 ${steps * 100}%`}, {translate: '0 0'}], {...timing, fill: 'backwards'});
    settle(animation).then(() => {
        element.textContent = digit;
    });

    return animation;
}
